/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeAuthResetPassword = 'route-_auth-reset-password',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	root = 'root',
	current = 'routes/($lang)._auth.reset-password',
}

/* -------------------------------------------------------------------------------------------------
 * Search params
 * -----------------------------------------------------------------------------------------------*/

enum SEARCH_PARAMS {
	email = 'email',
}

/* -----------------------------------------------------------------------------------------------*/

export {
	I18NEXT as RESET_PASSWORD_I18NEXT,
	ROUTE_LOADER as RESET_PASSWORD_ROUTE_LOADER,
	SEARCH_PARAMS as RESET_PASSWORD_SEARCH_PARAMS,
}
